import { render, staticRenderFns } from "./MarketingActivationDetail.vue?vue&type=template&id=437aef58&scoped=true&"
import script from "./MarketingActivationDetail.vue?vue&type=script&lang=js&"
export * from "./MarketingActivationDetail.vue?vue&type=script&lang=js&"
import style0 from "./MarketingActivationDetail.vue?vue&type=style&index=0&id=437aef58&prod&lang=css&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437aef58",
  null
  
)

export default component.exports